import React, { useEffect, useState } from 'react';
import { Popover, Spin, Tag as AntdTag, Tooltip } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { loadIOCNotes } from '../../../../redux/actions/ioc';
import styles from './notes.module.sass';
import { NoteDetails } from './NoteDetails';
import { NoteHeader } from './NoteHeader';
import { NoteAvatar } from './NoteAvatar';
import { STATUS } from '../../../../redux/constants';
import { ReactComponent as three_dots } from '../../../../assets/icons/three_dots.svg';
import Icon from '@ant-design/icons';
import { NoteAdd, NoteAddEdit } from './NoteAddEdit';

function Note({ note, setEditModalVisibility, iocUUID }) {
  return (
    <Popover
      overlayClassName={styles['note-details-container']}
      placement="bottomLeft"
      title={
        <NoteHeader
          noteUUID={note.uuid}
          noteDescription={note.note}
          setEditModalVisibility={setEditModalVisibility}
          createdAt={note.created}
          fullName={note.created_by}
          isMine={note.is_mine}
        />
      }
      content={
        <NoteDetails
          description={note.note}
          isMine={note.is_mine}
          noteUUID={note.uuid}
          iocUUID={iocUUID}
        />
      }
    >
      <AntdTag className={styles['note']}>
        <NoteAvatar isMine={note.is_mine} fullName={note.created_by} />
        <span
          style={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {note.note}
        </span>
      </AntdTag>
    </Popover>
  );
}

export function NotesList({ iocUUID, feedUUID, expanded }) {
  const [isAddNoteModalVisible, setIsAddNoteModalVisible] = useState(false);
  const [isEditNoteModalVisible, setIsEditNoteModalVisible] = useState({
    visibility: false,
    description: '',
    uuid: null,
  });
  // const [iocUUID, setIOCUUID] = useState(iocUUID);

  const dispatch = useDispatch();
  const notes = useSelector((state) => state.ioc.iocNotes);
  const notesLoadingStatus = useSelector((state) => state.ioc.iocNotesStatus);
  useEffect(() => {
    if (!(iocUUID && feedUUID)) {
      return () => {};
    }
    if (expanded) {
      dispatch(loadIOCNotes(iocUUID, feedUUID));
    }
  }, [expanded]);

  const renderNotes = () => {
    const displayedNotes = notes.slice(0, 3);
    const notesInPopover = notes.slice(3);

    const renderNote = (note, id) => (
      <Note
        setEditModalVisibility={setIsEditNoteModalVisible}
        key={id}
        note={note}
        iocUUID={iocUUID}
      />
    );
    const renderAddButton = () => (
      <Tooltip
        title={
          notes?.length <= 4
            ? ''
            : 'Note limit reached. You cannot create more than 5 notes for this IOC in your organization.'
        }
      >
        <AntdTag
          onClick={() =>
            notes?.length <= 4 ? setIsAddNoteModalVisible(true) : null
          }
          className={
            notes?.length <= 4
              ? styles['add-note-chip']
              : styles['add-note-chip-disabled']
          }
        >
          <span>+ Add Note</span>
        </AntdTag>
      </Tooltip>
    );
    if (notes?.length <= 3) {
      return (
        <>
          {notes?.map(renderNote)}
          {renderAddButton()}
        </>
      );
    }
    return (
      <>
        {displayedNotes?.map(renderNote)}
        <Popover
          overlayClassName={styles['note-details-container']}
          placement="bottomRight"
          title={notesInPopover?.map((note, id) => (
            <React.Fragment key={id}>
              <NoteHeader
                noteUUID={note?.uuid}
                noteDescription={note?.note}
                setEditModalVisibility={setIsEditNoteModalVisible}
                idx={id}
                createdAt={note?.created}
                fullName={note?.created_by}
                isMine={note?.is_mine}
              />
              <NoteDetails
                idx={id}
                isMine={note?.is_mine}
                noteUUID={note?.uuid}
                description={note?.note}
                iocUUID={iocUUID}
              />
            </React.Fragment>
          ))}
        >
          <Icon
            style={{
              width: '24px',
              margin: '5px',
              fontSize: '24px',
              transform: 'rotate(-90deg)',
              verticalAlign: 'middle',
            }}
            component={three_dots}
          />
        </Popover>
        {renderAddButton()}
      </>
    );
  };

  return (
    <div
      style={{ display: 'flex', alignItems: 'center', flexBasis: 'content' }}
    >
      {notesLoadingStatus === STATUS.LOADING && <Spin />}
      {notesLoadingStatus !== STATUS.LOADING && renderNotes()}
      {isEditNoteModalVisible.visibility ? (
        <NoteAddEdit
          isVisible={isEditNoteModalVisible.visibility}
          isEditing={true}
          setModalVisibility={setIsEditNoteModalVisible}
          description={isEditNoteModalVisible.description}
          noteUUID={isEditNoteModalVisible.uuid}
          iocUUID={iocUUID}
          feedUUID={feedUUID}
        />
      ) : (
        <NoteAddEdit
          isVisible={isAddNoteModalVisible}
          isEditing={false}
          setModalVisibility={setIsAddNoteModalVisible}
          iocUUID={iocUUID}
          feedUUID={feedUUID}
        />
      )}
    </div>
  );
}
